import Header from "@/components/ui/Header";
import Footer from "@/components/ui/Footer";
import { Toaster } from "../ui/Sonner";
import { cn } from "@/util/cn";
import { useProfileContext } from "@/contexts/ProfileContext";
import { UserStatus } from "@/api/SolarCloudApi";

type MainLayoutProps = {
  children: React.ReactNode;
  className?: string;
};
export default function MainLayout({ children, className }: MainLayoutProps) {
  const profile = useProfileContext();
  const authentication = profile.authentication;
  let mainLink = "https://www.solarcloud.com.au/";
  // if (authentication?.loggedIn) {
  //   switch (authentication?.user.status) {
  //     default:
  //     case UserStatus.ACTIVE:
  //     case UserStatus.PENDING:
  //       mainLink = "/dashboard/";
  //       break;

  //     case UserStatus.UNVERIFIED:
  //     case UserStatus.VERIFIED:
  //     case UserStatus.PROFILED:
  //       mainLink = "/buypanels";
  //       break;

  //     case UserStatus.CANCELLED:
  //     case UserStatus.COMPROMISED:
  //     case UserStatus.INACTIVE:
  //       mainLink = "/signup/error";
  //       break;
  //   }
  // }

  return (
    <div className={cn("w-full h-full", className)}>
      <Header className="bg-brand-neutral-800" mainLink={mainLink} />
      <main className="pb-4">
        <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
          {children}
          {/* <Outlet /> */}
          <Toaster />
        </div>
      </main>
      <Footer className="bg-brand-neutral-800" mainLink={mainLink} />
    </div>
  );
}
